import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.inverted = false
  }

  toggle(event) {
    event.preventDefault()

    this.inverted = !this.inverted

    document.body.classList.toggle(
      "inverted",
      this.inverted
    )
  }
}